import LampModuleArtIcon from './component'

export default LampModuleArtIcon
